export const Arrow = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M5.2002 2.38953L9.39127 6.5806C10.1723 7.36165 10.1723 8.62798 9.39127 9.40903L5.2002 13.6001"
        stroke="#5D6977"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
